import { BookShipmentErrorFromJSON } from "@freightsimple/generated-dashboard-openapi-client/models/BookShipmentError";
import { ResponseError } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import type { BookingFieldViolation } from "@freightsimple/generated-dashboard-openapi-client/models/BookingFieldViolation";

/**
 * The per-field reasons a booking was refused, or undefined when the failure
 * was anything else.
 *
 * The book endpoint answers 400 with a `BookShipmentError` body when the
 * shipment is not ready to book (a missing contact phone, a deadline on or
 * before the pickup date). Those are the customer's to fix, so Review shows
 * them instead of sending the customer to "nearly there", which is the right
 * screen for every other failure and stays the fallback.
 */
export async function bookShipmentViolationsFromError(
  e: unknown,
): Promise<BookingFieldViolation[] | undefined> {
  if (!(e instanceof ResponseError) || e.response.status !== 400) {
    return undefined;
  }
  try {
    const body = BookShipmentErrorFromJSON(await e.response.json());
    return body.violations.length > 0 ? body.violations : undefined;
  } catch {
    // Not a BookShipmentError body (a message-only refusal in Micronaut's
    // default error shape, or no JSON at all): nothing the customer can act on.
    return undefined;
  }
}
